import { useEffect, useState } from 'react';

import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { useAppSelector } from '@/store';

import type { RecreateBanksListInterface } from '../types/recreate-banks';

interface IProps {
  isRequestAutoTypeUsedAuto: boolean;
  setError: (error: string) => void;
}

const useBanksList = ({ isRequestAutoTypeUsedAuto, setError }: IProps) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const [banks, setBanks] = useState<RecreateBanksListInterface[]>([]);
  const isAllBanksChecked = banks.every((bank) => bank.checked);
  const [isCommercialChecked, setIsCommercialChecker] = useState(
    isRequestAutoTypeUsedAuto
  );

  const toggleIsCommercialChecked = () => {
    setIsCommercialChecker(!isCommercialChecked);
  };

  const resetIsCommercialChecked = () => {
    setIsCommercialChecker(false);
  };

  const handleBankChecked = (index: number) => {
    const newBanks = banks.slice();
    newBanks[index].checked = !newBanks[index].checked;
    setBanks(newBanks);
    setError('');
  };

  const handleCheckAll = () => {
    setBanks((prev) =>
      prev.map((item) => ({ ...item, checked: !isAllBanksChecked }))
    );
    setError('');
  };

  const resetCheckedBanks = () => {
    setBanks((prev) => prev.map((item) => ({ ...item, checked: false })));
    setError('');
  };

  useEffect(() => {
    if (!dicts || !dicts?.[DictTypes.Banks]?.content) return;

    const preparedBanks = dicts?.[DictTypes.Banks]?.content
      .filter((item) => item.is_active)
      .map((item) => ({
        code: item.name,
        name: item.fullname,
        icon:
          item.icon ||
          BANKS_ICONS_NAMES[item.name as keyof typeof BANKS_ICONS_NAMES]
            ?.icon ||
          '',
        checked: false
      }));
    setBanks(preparedBanks);
    setError('');
  }, [dicts]);

  return {
    banks,
    isAllBanksChecked,
    handleBankChecked,
    handleCheckAll,
    resetCheckedBanks,
    isCommercialChecked,
    toggleIsCommercialChecked,
    resetIsCommercialChecked
  };
};

export default useBanksList;
